import { render, staticRenderFns } from "./import-invoice.vue?vue&type=template&id=3f8bba86&scoped=true"
import script from "./import-invoice.vue?vue&type=script&lang=js"
export * from "./import-invoice.vue?vue&type=script&lang=js"
import style0 from "./import-invoice.vue?vue&type=style&index=0&id=3f8bba86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8bba86",
  null
  
)

export default component.exports